import { createSelector } from 'reselect';
import { AppState } from '../reducers';

const integrationsResourceSelector = (state: AppState) => state.dynamics;

export const dynamicsSelfSelector = createSelector(integrationsResourceSelector, (dynamics) => dynamics.self);
